import { twMerge } from 'tailwind-merge';

import { Button } from 'components/button';

import { BurgerButtonProps } from './types';

export const BurgerButton = ({
  isOpen,
  onClick,
  className,
}: BurgerButtonProps) => {
  return (
    <Button
      hasMinWidth
      variant="text"
      onClick={onClick}
      className={twMerge(
        'flex h-6 w-6 items-center justify-center rounded-full',
        className
      )}
    >
      <div className="flex flex-col space-y-1">
        <div
          className={twMerge(
            'bg-black-primary h-0.5 w-5 transition-all duration-200',
            isOpen && 'translate-y-1.5 rotate-45'
          )}
        />
        <div
          className={twMerge(
            'bg-black-primary h-0.5 w-5 transition-all duration-200',
            isOpen && 'opacity-0'
          )}
        />
        <div
          className={twMerge(
            'bg-black-primary h-0.5 w-5 transition-all duration-200',
            isOpen && '-translate-y-1.5 -rotate-45'
          )}
        />
      </div>
    </Button>
  );
};
